export default "__VITE_ASSET__eH9yJzXX__"